import { ADD_PAGE } from "@/store/mutation-types";

export default {
  [ADD_PAGE](state, { page, name }) {
    state.pages = { ...state.pages, [name]: page };
  }
};
